export default "__VITE_ASSET__C6Jxftj7__"